import { getParameterByName } from '@qdabra/forms-shared/urlHelpers';
import { URL_PARAMETER_CLOSE_TARGET } from '../../constants/url.parameter.names';

const $ = window.jQuery;

function formCloser(renderTarget) {
    function getCloseDestination() {
        return getParameterByName(URL_PARAMETER_CLOSE_TARGET);
    }

    function closeForm() {
        var dest = getCloseDestination();

        if (dest) {
            window.location = dest;
        } else {
            $(renderTarget).html(
                "<div style='text-align:center; font-size:18pt'>This form has been closed.</div>",
            );
        }
    }

    return {
        closeForm,
    };
}

export default formCloser;
